import { useState } from 'react';

export default function FAQSection() {
  const faqs = [
    {
      question: "What is manufacturing execution system software?",
      answer: "MES software serves as a central hub for managing, controlling and optimizing manufacturing execution and processes. It empowers your teams to make informed decisions across the shop floor and address issues in real time."
    },
    {
      question: "Why should my company use MES software for manufacturing?",
      answer: "MES software improves operational efficiency by providing real-time visibility into production processes, reducing downtime, optimizing resource allocation, ensuring quality control, and enabling data-driven decision making across your manufacturing operations."
    },
    {
      question: "How can   Infor MES solution support the manufacturing industry?",
      answer: " Infor MES solution supports the manufacturing industry by providing comprehensive digital transformation tools, enhancing production efficiency, ensuring quality compliance, optimizing supply chain management, and facilitating seamless integration with existing systems and IoT devices."
    },
    {
      question: "Can I customize  Infor MES software solution to my needs?",
      answer: "Yes,  Infor  MES software solutions are highly customizable to meet your specific manufacturing requirements. The platform offers modular components, flexible configurations, industry-specific templates, and integration capabilities with your existing systems."
    },
  ];

  const [openIndex, setOpenIndex] = useState(0);

  const toggleFAQ = (index) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  return (
    <div className="min-h-screen" style={{ backgroundColor: "white" }}>
      {/* <header className="bg-black text-white p-4">
        <div className="container mx-auto flex justify-between items-center">
          <nav className="flex space-x-8">
            <a href="#" className="hover:text-gray-300">Software & products</a>
            <a href="#" className="hover:text-gray-300">Solutions & services</a>
            <a href="#" className="hover:text-gray-300">Industries</a>
            <a href="#" className="hover:text-gray-300">Training & support</a>
          </nav>
          <div className="flex items-center space-x-4">
            <button className="p-2">
              <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z" />
              </svg>
            </button>
            <span>EN</span>
            <button className="p-2">
              <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M16 11V7a4 4 0 00-8 0v4M5 9h14l1 12H4L5 9z" />
              </svg>
            </button>
            <button className="flex items-center">
              <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6 mr-1" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z" />
              </svg>
              Log in
            </button>
          </div>
        </div>
      </header> */}
      
      <main className="container mx-auto p-4 sm:p-8">
        <h1 className="text-2xl sm:text-4xl font-bold text-[#0d0d36] mb-8">Frequently asked questions</h1>
        
        <div className="border-t border-gray-700">
          {faqs.map((faq, index) => (
            <div key={index} className="border-b border-gray-700">
              <button 
                className="w-full text-left p-4 sm:p-6 flex justify-between items-center focus:outline-none"
                onClick={() => toggleFAQ(index)}
              >
                <h2 className={`text-lg sm:text-2xl font-medium ${index === openIndex ? 'text-black' : 'text-[#0d0d36]'}`}>
                  {faq.question}
                </h2>
                <span className="text-2xl sm:text-3xl text-[#0d0d36]">
                  {index === openIndex ? "−" : "+"}
                </span>
              </button>
              
              <div 
                className={`overflow-hidden transition-all duration-300 ${index === openIndex ? 'max-h-96 bg-green-100' : 'max-h-0'}`}
                style={{ backgroundColor: index === openIndex ? "#d2f5e3" : "transparent" }}
              >
                <p className="p-4 sm:p-6 text-black">
                  {faq.answer}
                </p>
              </div>
            </div>
          ))}
        </div>
      </main>

      <div className="fixed bottom-8 right-8">
        <button className="bg-yellow-500 text-black rounded-full w-16 h-16 flex items-center justify-center shadow-lg">
          <svg xmlns="http://www.w3.org/2000/svg" className="h-8 w-8" fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M8 10h.01M12 10h.01M16 10h.01M9 16H5a2 2 0 01-2-2V6a2 2 0 012-2h14a2 2 0 012 2v8a2 2 0 01-2 2h-5l-5 5v-5z" />
          </svg>
        </button>
      </div>
    </div>
  );
}